import { FC } from 'react';

import { withA11yVisuallyHidden } from '@telialt/common-a11y/src/withA11yVisuallyHidden';
import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { formatCurrency, withParams } from '@telialt/utils/src/helpers';

import { PLAN_CARD_TEST_ID } from '../../constants';
import { PlanCardModel } from '../../model';
import { PriceTag } from '../../PlanCard.styles';

const PriceTagAccessible = withA11yVisuallyHidden(PriceTag);

type PriceProps = {
    isNewPrice?: boolean;
    children: string | number;
} & PlanCardModel.NegativeProp;

export const Price: FC<PriceProps> = ({ isNewPrice, isNegative, children: price }) => {
    const { t } = useTranslations();
    const priceFormatted = typeof price === 'number' ? formatCurrency(price) : price;
    const readablePrice = withParams(
        isNewPrice ? t['plans.euro_per_month.new_price.aria_label'] : t['plans.euro_per_month.aria_label'],
        { amount: priceFormatted },
    );

    return (
        <PriceTagAccessible
            $negative={isNegative}
            $variant={isNewPrice ? 'attention' : 'neutral'}
            accessible={readablePrice}
            data-test={PLAN_CARD_TEST_ID.PRICE}
        >
            {priceFormatted} {t['plans.euro_per_month']}
        </PriceTagAccessible>
    );
};
